import { initialState } from "./../initialState";
import * as TaskActions from "./taskActions";

export const taskReducer = (state = initialState.tasks, action) => {
    switch (action.type) {
        case TaskActions.REQUEST_TASKS:
            return {
                ...state,
                fetching: true,
                workOrderNumber: action.workOrderNum,
            };

        case TaskActions.CLEAR_TASKS:
            return {
                ...state,
                tasks: [],
            };

        case TaskActions.REQUEST_TASKS_SUCCEEDED:
            return {
                ...state,
                ...action.tasks,
                fetching: false,
            };

        case TaskActions.TASK_RELOAD_SUCCEEDED:
            const existingTasks = [...state.tasks];
            const existingTaskIndex = existingTasks.findIndex((task) => task.workOrderNumber === action.task.workOrderNumber);

            // remove the existing assignment and replace it with updated
            // task
            if (existingTaskIndex !== -1) {
                existingTasks.splice(existingTaskIndex, 1, action.task);
            }

            return {
                ...state,
                tasks: existingTasks,
            };

        case TaskActions.REQUEST_WORKORDER_SUCCESS:
            return { ...state, workorderData: action.workorderData };

        case TaskActions.CLEAR_WORKORDER_DATA:
            return {
                ...state,
                workorderData: {
                    activityQuestions: [],
                    workorderData: {},
                    //workorderInfo: {},
                    confinedSpaceInfo: {},
                },
            };

        case TaskActions.REQUEST_WORKORDER_PURCHASE_NUM_SUCCESS:
            return { ...state, purchaseOrderNumber: action.purchaseOrderNumber };
        case TaskActions.REQUEST_WORKORDER_VENDOR_MANAGER_SUCCESS:
            return { ...state, vendorManagerByOrder: action.vendorManagerByOrder };
        case TaskActions.UPDATE_WORKORDER_STATUS:
            return {
                ...state,
                workorderData: {
                    ...state.workorderData,
                    workorderData: {
                        ...state.workorderData.workorderData,
                        status: action.status,
                        statusId: action.status.id,
                        statusName_en: action.status.name_en,
                        statusName_fr: action.status.name_fr,
                    },
                },
            };
        case TaskActions.GET_TASK_ASSIGNMENT_SUCCESS:
            return { ...state, assignmentInformation: action.assignmentInformation };

        case TaskActions.REQUEST_TASKS_FAILED:
            return {
                ...state,
                ...initialState.tasks.tasks,
                fetching: false,
            };
        case TaskActions.CLEAR_TASK_COUNTS:
            return {
                ...state,
                counts: initialState.tasks.counts,
            };

        case TaskActions.INCOMPLETE_TASK_RESPONSE:
            return { ...state, incompleteTaskResponse: action.incompleteTaskResponse };
        case TaskActions.CLEAR_ASSIGNMENTS_INFO:
            return { ...state, assignmentInformation: initialState.tasks.assignmentInformation };
        case TaskActions.REQUEST_TO_TAB_CHANGE:
            return { ...state, requestTabValue: action.data };
        case TaskActions.REQUEST_TO_ADD_FOLLOWUP:
            return { ...state, isRequestToAddFollowup: action.data };
        case TaskActions.SHOW_FOLLOWUPS:
            return { ...state, isShowFollowups: action.data };
        case TaskActions.COMPLETION_PAYLOAD:
            return { ...state, completionData: action.data };
        case TaskActions.BUTTON_DISABLED:
            return { ...state, isButtonDisabled: action.data };
        case TaskActions.BILLLING_REASON_MANDATORY:
            return { ...state, isBillingReasonMandatory: action.payload };
        case TaskActions.GET_WORKORDER_CANCELLED_REASON_SUCCESS:
            return { ...state, workOrderCancelledReasons: action.cancelledWorkOrderReasons?.d?.results[0] };
        case TaskActions.DISABLE_BELL_TO_SEND_BUTTON:
            return { ...state, disbaleButton: action.payload };
        default:
            return state;
    }
};

export const manageAllStatusReducer = (state = initialState.allStatus, action) => {
    switch (action.type) {
        case TaskActions.REQUEST_ALL_STATUS_SUCCEEDED:
            return [...action.allStatus];
        default:
            return state;
    }
};
